// import i18n from 'i18next';
import axios from 'axios';
import { getFavoriteTalents } from './TalentsService';

export const updateJob = async (data) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}job/update`, data);
        if (response.data) {
        }
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const updateJobField = async (data) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}job/updateField`, data);
        if (response.data) {
        }
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const updateApplicationField = async (data) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}job/updateApplicationField`, data);
        if (response.data) {
        }
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const getJob = async (job_slug) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}job/getJobBySlug/${job_slug}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};
export const fetchJobsByEmployer = async (employer_id, page = 1, per_page = 10) => {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}job/getJobsByEmployer/${employer_id}?page=${page}&per_page=${per_page}`
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching jobs by employer:', error);
        throw error.response?.data?.message || 'Failed to fetch jobs';
    }
};


export const getJobByID = async (job_id) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}job/getJobById/${job_id}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};
export const deleteJob = async (job_id, token) => {
    try {
        const response = await axios.delete(`${process.env.REACT_APP_API_URL}job/delete/${job_id}?token=${token}`);
    } catch (error) {
        console.log(error, 'error');
        throw error.response.data;
    }
};


export const getJobsList = async (page, per_page, max_pages, filters = {}, status, userId) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}job/getJobsList`, {
            params: {
                page: page,
                per_page: per_page,
                max_pages: max_pages,
                filters: filters,
                jobseeker_status: status,
                userId
            }
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const getSimilarJobs = async (jobId) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}job/getSimilarJobs/${jobId}`);
        return response.data.similarJobs;
    } catch (error) {
        throw error.response.data;
    }
};
export const getBestMatches = async (jobId) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}job/getBestMatches/${jobId}`);
        return response.data.bestMatches;
    } catch (error) {
        throw error.response.data;
    }
};
export const getJobApplicationsList = async (id, token, page, per_page, filters = {}) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}job/getJobApplicationsList/${id}`, {
            params: {
                token: token,
                page: page,
                per_page: per_page,
                filters: filters
            }
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const sendJobProposal = async (data) => {
    try {

        const response = await axios.post(`${process.env.REACT_APP_API_URL}job/sendProposal`, data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const addJobToFavourites = async (data) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}job/addToFavourites`, data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const removeJobFromFavourites = async (data) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}job/removeFromFavourites`, data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const getEmployerApplicationsList = async (employer_id, token, page = 1, per_page = 10, filters = {}) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}job/getEmployerApplicationsList/${employer_id}`, {
            params: {
                token: token,
                page: page,
                per_page: per_page,
                filters: filters
            }
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const deleteApplication = async (applicationId) => {
    try {
        const response = await axios.delete(`${process.env.REACT_APP_API_URL}job/deleteApplication/${applicationId}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};
export const deleteCandidates = async (userId, talentId) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}talents/favorites/add`, {
            userId: userId,
            talentId: talentId,
            listIds: [],
        });
        // const response = await getFavoriteTalents(userId, 1, per_page, filters)
        console.log(response, 'response')
        return response;
    } catch (error) {
        console.log(error, 'error')
        throw error.response.data;
    }
};
export const incrementJobViews = async (jobId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}job/increment-views/${jobId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to increment job views');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error incrementing job views:', error);
    }
};

export const incrementImpressions = async (jobId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}job/increment-impressions/${jobId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to increment impressions');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error incrementing impressions:', error);
    }
};